(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8138],{

/***/ 92508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ BulletedList; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var BulletedList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "BulletedList",
  componentId: "sc-1sbizlb-0"
})(["font-size:16px;line-height:1.3;list-style:", ";margin-left:24px;display:flex;flex-direction:column;gap:21px;> li::marker{color:", ";}@media screen and (max-width:1047px){font-size:15px;line-height:1.6;gap:12px;}"], function (_ref) {
  var listStyle = _ref.listStyle;
  return listStyle !== null && listStyle !== void 0 ? listStyle : 'disc';
}, function (_ref2) {
  var listStyle = _ref2.listStyle;
  return listStyle === 'decimal' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey;
});

/***/ }),

/***/ 34125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ DisclaimerPage; }
});

// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Ir/index.tsx
var Ir = __webpack_require__(87661);
// EXTERNAL MODULE: ./src/components/layouts/Ir/BulletedList.tsx
var BulletedList = __webpack_require__(92508);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(45775);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Disclaimer/index.tsx










var DisclaimerPage = function DisclaimerPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      titleText: "Disclaimer",
      subTitleText: "\u514D\u8CAC\u4E8B\u9805"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        pc: 63,
        sp: 50
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BulletedList/* BulletedList */.h, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
          children: "\u5F53\u793E\u304C\u958B\u793A\u3059\u308B\u696D\u7E3E\u4E88\u60F3\u3001\u6226\u7565\u3001\u65B9\u91DD\u3001\u76EE\u6A19\u7B49\u306E\u3046\u3061\u3001\u6B74\u53F2\u7684\u4E8B\u5B9F\u3067\u306F\u306A\u3044\u3082\u306E\u306F\u5C06\u6765\u306E\u898B\u901A\u3057\u306B\u95A2\u3059\u308B\u8A18\u8FF0\u3067\u3042\u308A\u3001\u3053\u308C\u3089\u306F\u3001\u5F53\u793E\u304C\u305D\u306E\u6642\u70B9\u3067\u5165\u624B\u3057\u3066\u3044\u308B\u60C5\u5831\u53CA\u3073\u5408\u7406\u7684\u3067\u3042\u308B\u3068\u5224\u65AD\u3055\u308C\u308B\u4E00\u5B9A\u306E\u524D\u63D0\u306B\u57FA\u3065\u304F\u8A08\u753B\u3001\u671F\u5F85\u3001\u5224\u65AD\u3092\u6839\u62E0\u3068\u3057\u3066\u304A\u308A\u3001\u5B9F\u969B\u306E\u696D\u7E3E\u7B49\u306F\u69D8\u3005\u306A\u30EA\u30B9\u30AF\u3084\u4E0D\u78BA\u5B9A\u8981\u56E0\u306B\u3088\u308A\u5927\u304D\u304F\u7570\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
          children: "\u672C\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306F\u6295\u8CC7\u52E7\u8A98\u3092\u76EE\u7684\u3068\u3057\u305F\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u6295\u8CC7\u306B\u95A2\u3059\u308B\u6C7A\u5B9A\u306F\u5229\u7528\u8005\u3054\u81EA\u8EAB\u306E\u3054\u5224\u65AD\u306B\u304A\u3044\u3066\u884C\u308F\u308C\u308B\u3088\u3046\u304A\u9858\u3044\u3044\u305F\u3057\u307E\u3059\u3002"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
          children: "\u672C\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306E\u63B2\u8F09\u5185\u5BB9\u306B\u3064\u3044\u3066\u306F\u7D30\u5FC3\u306E\u6CE8\u610F\u3092\u6255\u3063\u3066\u304A\u308A\u307E\u3059\u304C\u3001\u63B2\u8F09\u3055\u308C\u305F\u60C5\u5831\u306E\u8AA4\u308A\u3084\u30C7\u30FC\u30BF\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u306A\u3069\u306B\u3088\u3063\u3066\u751F\u3058\u305F\u969C\u5BB3\u306A\u3069\u306B\u95A2\u3057\u307E\u3057\u3066\u306F\u3001\u5F53\u793E\u306F\u4E00\u5207\u8CAC\u4EFB\u3092\u8CA0\u3046\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u306E\u3067\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
          children: "\u5F53\u793E\u306F\u4E88\u544A\u306A\u3057\u306B\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u4E0A\u306E\u60C5\u5831\u306E\u5909\u66F4\u3001\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306E\u904B\u55B6\u3092\u4E2D\u65AD\u307E\u305F\u306F\u4E2D\u6B62\u3055\u305B\u3066\u3044\u305F\u3060\u304F\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u4E88\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
          children: "\u5F53\u793E\u306F\u3001\u672C\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u304B\u3089\u30EA\u30F3\u30AF\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u308B\u4ED6\u306E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306E\u60C5\u5831\u306B\u95A2\u3057\u3066\u3044\u304B\u306A\u308B\u4FDD\u8A3C\u3092\u3059\u308B\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
        })
      })]
    })]
  });
};

DisclaimerPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '株主・投資家向け情報',
    path: '/ir'
  }, {
    name: '免責事項',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u514D\u8CAC\u4E8B\u9805",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u514D\u8CAC\u4E8B\u9805\u306B\u3064\u3044\u3066\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'ir/disclaimer/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/ir/disclaimer.tsx


/***/ }),

/***/ 78395:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/disclaimer",
      function () {
        return __webpack_require__(34125);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,5548,4535,9774,2888,179], function() { return __webpack_exec__(78395); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);